const Title = () => <span class="mx-2 fs-4">Sites Inventory</span>;
export default Title;
